module.exports = __webpack_public_path__ + "static/media/ticket.bc882090.svg";